export default __webpack_public_path__ + "static/media/alert_2.be86d47b.png";